import { useMutation } from '@tanstack/react-query';

import { apiRequest } from '../api';
import type { ZendeskTicketLookup } from '../types';

export function useLookupZendeskTicket() {
  return useMutation({
    mutationFn: (ticketId: string) => apiRequest<ZendeskTicketLookup>(`/api/zendesk/${ticketId.trim()}`),
  });
}
